import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deletePlant } from '../../api/production-request-api/index.js';
import { toast } from '@pella/sash-framework';
import { QUERY_KEYS } from '../../data/constants';

/**
 * Hook containing mutation function for deleting a Plant.
 */
export const useDeletePlant = () => {
  const queryClient = useQueryClient();

  return useMutation({
    /**
     * mutateFn - Function to call deletePlant.
     * @param {Pella.ProductionRequestAPI.Plant['id']} id - The ID of the Plant to delete.
     */
    mutationFn: (id) => deletePlant(id),
    onSuccess: () => {
      toast.success('Plant deleted successfully!');
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.PLANT_DATA] });
    },
  });
};
